"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderedListMenu = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const OrderedListMenu_style_1 = require("./OrderedListMenu.style");
const Header_1 = require("./components/Header");
const Preview_1 = require("./components/Preview");
const CollapseTab_1 = require("./components/CollapseTab");
const SelectionTab_1 = require("./components/SelectionTab");
const Footer_1 = require("./components/Footer");
const react_1 = require("react");
const OrderedListContext_1 = require("./OrderedListContext");
const TextListOptionMenuOverview_1 = require("../TextListOptionMenuOverview");
function OrderedListMainMenu() {
    const { advancedOrderedStyleFeatureFlag } = (0, react_1.useContext)(OrderedListContext_1.OrderedListContext);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Preview_1.Preview, {}), advancedOrderedStyleFeatureFlag ? (0, jsx_runtime_1.jsx)(CollapseTab_1.CollapseTab, {}) : (0, jsx_runtime_1.jsx)(SelectionTab_1.SelectionTab, {}), (0, jsx_runtime_1.jsx)(Footer_1.Footer, {})] }));
}
function OrderedListAddMenu() {
    const { variant, minLevel, maxLevel, defaultOptions, symbols, defaultRegex, regexOptions, selectedValues, acrossPages, labels, continueAcrossPagesEditable, onSave, onCancel, onActiveTabChange, } = (0, react_1.useContext)(OrderedListContext_1.OrderedListContext);
    const onCancelHandler = () => {
        onCancel();
        onActiveTabChange === null || onActiveTabChange === void 0 ? void 0 : onActiveTabChange(0);
    };
    return ((0, jsx_runtime_1.jsx)(OrderedListMenu_style_1.StyledOptionMenuWrapper, { children: (0, jsx_runtime_1.jsx)(TextListOptionMenuOverview_1.TextListOptionMenuOverview, { variant: variant, minLevel: minLevel, maxLevel: maxLevel, defaultOptions: defaultOptions, symbols: symbols, defaultRegex: defaultRegex, regexOptions: regexOptions, selectedValues: selectedValues, acrossPages: acrossPages, labels: labels, continueAcrossPagesEditable: continueAcrossPagesEditable, onCancel: onCancelHandler, onSave: onSave }) }));
}
function TabsContent() {
    const { activeTabIndex } = (0, react_1.useContext)(OrderedListContext_1.OrderedListContext);
    switch (activeTabIndex) {
        case 0:
            return (0, jsx_runtime_1.jsx)(OrderedListMainMenu, {});
        case 1:
            return (0, jsx_runtime_1.jsx)(OrderedListAddMenu, {});
        default:
            return (0, jsx_runtime_1.jsx)(OrderedListMainMenu, {});
    }
}
function OrderedListMenu() {
    return ((0, jsx_runtime_1.jsxs)(OrderedListMenu_style_1.StyledContainer, { children: [(0, jsx_runtime_1.jsx)(Header_1.Header, {}), (0, jsx_runtime_1.jsx)(TabsContent, {})] }));
}
exports.OrderedListMenu = OrderedListMenu;
//# sourceMappingURL=OrderedListMenu.js.map